import React from 'react';
import { ResponsiveContainer, BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip } from 'recharts';

export const graphColors = ['#29b48f', '#0088FE', '#FF8042', '#FFBB28', '#8884d8', '#718096', '#82ca9d'];

export const MatrixHorizontalBar = ({ question }) => {
  const choices = question.questionChoicesAttributes || [];
  const cols = choices.filter(c => c.kind === 'column').sort((a, b) => a.position - b.position);
  const data = question.results || [];

  return (
    <ResponsiveContainer width="95%" height={320}>
      <BarChart layout="vertical" data={data} margin={{ top: 20, right: 30, left: 20, bottom: 5 }}>
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis type="number" />
        <YAxis dataKey="name" type="category" width={120} tickLine={false} tick={{ fontSize: 11 }} />
        <Tooltip />
        {cols.map((col, idx) => (
          <Bar
            key={col.id || col.position}
            dataKey={col.label}
            stackId="a"
            fill={graphColors[idx % graphColors.length]}
          />
        ))}
      </BarChart>
    </ResponsiveContainer>
  );
};

export const MatrixColumn = ({ question }) => {
  const choices = question.questionChoicesAttributes || [];
  const cols = choices.filter(c => c.kind === 'column').sort((a, b) => a.position - b.position);
  const data = question.results || [];

  return (
    <ResponsiveContainer width="95%" height={320}>
      <BarChart data={data} margin={{ top: 20, right: 30, left: 20, bottom: 40 }}>
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey="name" interval={0} angle={-15} textAnchor="end" height={60} tick={{ fontSize: 11 }} />
        <YAxis />
        <Tooltip />
        {cols.map((col, idx) => (
          <Bar
            key={col.id || col.position}
            dataKey={col.label}
            stackId="a"
            fill={graphColors[idx % graphColors.length]}
          />
        ))}
      </BarChart>
    </ResponsiveContainer>
  );
};

export const MatrixTable = ({ question }) => {
  const choices = question.questionChoicesAttributes || [];
  const rows = choices.filter(c => c.kind === 'row').sort((a, b) => a.position - b.position);
  const cols = choices.filter(c => c.kind === 'column').sort((a, b) => a.position - b.position);
  const data = question.results || [];

  return (
    <div className="table-responsive border rounded bg-white mt-3" style={{ overflow: 'hidden' }}>
      <table className="table table-hover mb-0" style={{ fontSize: '13px' }}>
        <thead style={{ backgroundColor: '#f8f9fa', color: '#718096', borderBottom: '1px solid #edf2f7' }}>
          <tr>
            <th className="font-weight-bold text-uppercase py-2 px-4" style={{ borderBottom: 'none' }}>
              Fila / Opción
            </th>
            {cols.map(col => (
              <th
                key={col.position}
                className="font-weight-bold text-uppercase py-2 px-2 text-center"
                style={{ borderBottom: 'none' }}
              >
                {col.label}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {rows.map((row, idx) => {
            const rowData = data.find(d => d.name === row.label) || {};
            return (
              <tr
                key={row.id || row.label}
                style={{ borderBottom: idx < rows.length - 1 ? '1px solid #edf2f7' : 'none' }}
              >
                <td className="py-2 px-4 font-weight-medium text-dark">{row.label}</td>
                {cols.map(col => (
                  <td key={col.position} className="py-2 px-2 text-center text-dark font-weight-bold">
                    {rowData[col.label] || 0}
                  </td>
                ))}
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};
